import { render, staticRenderFns } from "./aboutShengrongAn.vue?vue&type=template&id=be7d572e&scoped=true"
import script from "./aboutShengrongAn.vue?vue&type=script&lang=js"
export * from "./aboutShengrongAn.vue?vue&type=script&lang=js"
import style0 from "./aboutShengrongAn.vue?vue&type=style&index=0&id=be7d572e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7d572e",
  null
  
)

export default component.exports